<script lang="ts">
  import Router, { link, location, push } from 'svelte-spa-router';
  import Tailwindcss from './Tailwindcss.svelte';
  import { loginUser } from './components/auth/LoginUser';
  import Modal from './etc/Modal.svelte';
  import { modal } from './etc/stores.js';
  import ConfirmLoginInfo from './pages/ConfirmLoginInfo.svelte';
  import Login from './pages/Login.svelte';
  import ResetLoginInfo from './pages/ResetLoginInfo.svelte';
  import ResetLoginInfoReminders from './pages/ResetLoginInfoReminders.svelte';
  import ResetSettingPassword from './pages/ResetSettingPassword.svelte';
  import Initial from './pages/invitation/umobiled/Initial.svelte';
  import Main from './pages/invitation/umobiled/Main.svelte';
  import MnpPortin from './pages/invitation/umobiled/MnpPortin.svelte';
  import PaymentResult from './pages/invitation/umobiled/PaymentResult.svelte';
  import Received from './pages/invitation/umobiled/Received.svelte';

  import { routes } from './routes';
  import EnecomUtil from './util/EnecomUtil';

  const isEnecom: boolean = EnecomUtil.isEnecom();
  let isOpenSideMenu: boolean = false;

  const onClickSideMenuOpen = () => (isOpenSideMenu = true);
  const onClickSideMenuClose = () => (isOpenSideMenu = false);

  // cookieからユーザーを取得するようにする
  loginUser.loginFromCookie();

  const PATH_RESET_LOGIN_INFO = '/reset/login-info/';
  const PATH_RESET_LOGIN_INFO_REMINDERS = '/reset/login-info/reminders/';
  const PATH_RESET_SETTING_PASSWORD = '/reset/setting-password/';
  const PATH_CONFIRM_LOGIN_INFO = '/confirm/login-info/';
  const PATH_INVITAION_UMOBILED = '/invitation/umobiled/';
  const PATH_INVITAION_UMOBILED_INITIAL = '/invitation/umobiled/initial/';
  const PATH_INVITAION_UMOBILED_MAIN = '/invitation/umobiled/main/';
  const PATH_INVITAION_UMOBILED_RECEIVED = '/invitation/umobiled/received/';
  const PATH_INVITAION_UMOBILED_PAYMENT_RESULT = '/invitation/umobiled/payment-result/';
  const PATH_INVITAION_UMOBILED_MNP_PORTIN = '/invitation/umobiled/mnp-portin/';

  const PATH_EXCLUDE_LOGIN_LIST = [
    PATH_RESET_LOGIN_INFO,
    PATH_RESET_LOGIN_INFO_REMINDERS,
    PATH_RESET_SETTING_PASSWORD,
    PATH_CONFIRM_LOGIN_INFO
  ];

  // ログインの有無に関わらず パスワード確認・変更、ID確認画面は対象の画面に遷移
  if ($location === PATH_CONFIRM_LOGIN_INFO) {
    push(PATH_CONFIRM_LOGIN_INFO);
  } else if ($location === PATH_RESET_LOGIN_INFO) {
    push(PATH_RESET_LOGIN_INFO);
  } else if ($location === PATH_RESET_LOGIN_INFO_REMINDERS) {
    push(PATH_RESET_LOGIN_INFO_REMINDERS);
  } else if ($location.startsWith(PATH_RESET_SETTING_PASSWORD)) {
    push($location); // パラメータを引き継ぎたいので$locationをそのまま設定する
  } else if ($location.startsWith(PATH_INVITAION_UMOBILED)) {
    push($location); // パラメータを引き継ぎたいので$locationをそのまま設定する
  } else {
    // 上記以外はログインしていない場合には、ログイン画面にリダイレクト
    if (!$loginUser) {
      push('/login');
    }
  }

  const isMobileRouter = () => {
    return $loginUser.businessCode === 'UMOBILE_EA' || $loginUser.businessCode === 'UMOBILE_SONET';
  };
</script>

<svelte:head>
  <title>{isEnecom ? 'U-mobile  - ログイン' : 'U-NEXT 通信サービス マイページ'}</title>
  {#if !isEnecom}
    <link rel="icon" type="image/png" href="/favicon.png" />
  {/if}
</svelte:head>

<Tailwindcss />
<Modal show={$modal}>
  {#if $loginUser && !PATH_EXCLUDE_LOGIN_LIST.includes($location)}
    <!-- 情報表示があるかもしれないので 仮置のヘッダ（上部空白）を用意-->
    <header class="container sm:h-0 md:h-5 top-0 lef-0 z-0 w-screen">
      <div class="px-6 min-h-full justify-between items-center" />
    </header>
    <main class="container w-screen mx-auto main-container">
      <div class="min-h-hull">
        <div class="shadow md:rounded-lg bg-gray-50 border-1 min-h-full mb-20">
          <div class="flex flex-row menu-container">
            <!-- サイドメニュー -->
            <div class="flex-auto w-1/5 p-8 {isOpenSideMenu ? 'side-menu-opened' : 'side-menu-closed'}">
              <div class="flex flex-col space-y-4 justify-start">
                <div class="flex-1 text-sm">
                  <div>{$loginUser.sei} {$loginUser.mei}</div>
                  {#if !$loginUser.email}
                    <div class="font-bold text-red-600 mt-3">メールアドレスが未登録のため登録してください</div>
                  {/if}
                </div>
                <div class="flex-1">
                  <a href={`/contract/info/`} use:link class="anchor-link" on:click={onClickSideMenuClose}>
                    契約内容
                  </a>
                </div>
                <div class="flex-1">
                  <a href={`/customer/info/`} use:link class="anchor-link" on:click={onClickSideMenuClose}>
                    契約者情報
                  </a>
                </div>
                {#if $loginUser.businessCode !== 'WITHUNET' && !isMobileRouter()}
                  <div class="flex-1">
                    <a href={`/call/`} use:link class="anchor-link" on:click={onClickSideMenuClose}> 通話明細 </a>
                  </div>
                {/if}
                <div class="flex-1">
                  <a href={`/billing/`} use:link class="anchor-link" on:click={onClickSideMenuClose}> 請求明細 </a>
                </div>
                <div class="flex-1 logout-container">
                  <div class="border-t-2 mb-5" />
                  <a
                    href={`/login/`}
                    use:link
                    class="anchor-link"
                    on:click={() => {
                      loginUser.logout();
                      onClickSideMenuClose();
                    }}
                  >
                    ログアウト
                  </a>
                </div>
              </div>
            </div>
            {#if isOpenSideMenu}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <!-- svelte-ignore a11y-no-static-element-interactions -->
              <div class="mobile-side-menu-overlay" on:click={onClickSideMenuClose} />
            {/if}
            <!-- 描画が切り替わるメインコンテンツ -->
            <div class="flex-auto w-4/5 p-8 contents-container">
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <!-- svelte-ignore a11y-no-static-element-interactions -->
              <div on:click={onClickSideMenuOpen} class="menu-expander">
                <svg viewBox="0 0 100 80" width="40" height="40">
                  <rect width="70" height="10" />
                  <rect y="20" width="70" height="10" />
                  <rect y="40" width="70" height="10" />
                </svg>
              </div>
              <Router {routes} />
            </div>
          </div>
        </div>
      </div>
    </main>
  {:else if $location === PATH_CONFIRM_LOGIN_INFO}
    <ConfirmLoginInfo />
  {:else if $location === PATH_RESET_LOGIN_INFO}
    <ResetLoginInfo />
  {:else if $location === PATH_RESET_LOGIN_INFO_REMINDERS}
    <ResetLoginInfoReminders />
  {:else if $location.startsWith(PATH_RESET_SETTING_PASSWORD)}
    <ResetSettingPassword />
  {:else if $location.startsWith(PATH_INVITAION_UMOBILED_INITIAL)}
    <Initial />
  {:else if $location.startsWith(PATH_INVITAION_UMOBILED_MAIN)}
    <Main />
  {:else if $location.startsWith(PATH_INVITAION_UMOBILED_RECEIVED)}
    <Received />
  {:else if $location.startsWith(PATH_INVITAION_UMOBILED_PAYMENT_RESULT)}
    <PaymentResult />
  {:else if $location.startsWith(PATH_INVITAION_UMOBILED_MNP_PORTIN)}
    <MnpPortin />
  {:else}
    <Login />
  {/if}
</Modal>

<style lang="postcss">
  .anchor-link {
    @apply text-blue-800 text-lg no-underline hover:underline mr-1 mb-1;
  }
  .main-container {
    height: auto;
  }
  @media screen and (max-width: 640px) {
    .main-container {
      height: 100vh;
    }
  }
  @media screen and (max-width: 640px) {
    .menu-container {
      height: auto;
      min-height: 100vh;
    }
  }

  @media screen and (max-width: 640px) {
    .side-menu-closed {
      position: fixed;
      background: #ffffff;
      left: -250px;
      top: 0;
      bottom: 0;
      width: 250px;
      height: auto;
      min-height: 100vh;
      z-index: 1;
      transition: all 0.3s ease-out;
    }
    .side-menu-opened {
      position: fixed;
      background: #ffffff;
      left: 0;
      top: 0;
      bottom: 0;
      width: 250px;
      height: auto;
      min-height: 100vh;
      z-index: 1;
      transition: all 0.3s ease-out;
    }
  }

  @media screen and (max-width: 640px) {
    .contents-container {
      padding: 1rem;
    }
  }

  .mobile-side-menu-overlay {
    display: none;
  }
  @media screen and (max-width: 640px) {
    .mobile-side-menu-overlay {
      display: block;
      background-color: #000000;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      opacity: 0.3;
    }
  }
  .menu-expander {
    display: none;
  }
  @media screen and (max-width: 640px) {
    .menu-expander {
      display: block;
      position: absolute;
    }
  }
  .logout-container {
    padding-top: 16rem;
  }
  @media screen and (max-width: 640px) {
    .logout-container {
      padding-top: 0;
      position: absolute;
      bottom: 3rem;
    }
  }
</style>
